import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import { Textarea, Checkbox } from 'components/fields'
import { Span } from 'components/layout'
import { Button } from 'components/misc'
import { form } from 'helpers/decorators'
import { offlineAwardLeaderSignoffValidate } from 'models/awards'

import { PROGRESS_STATES } from 'constants/enums'

@form({
  form: 'TaskOfflineAwardLeaderSignoff',
  validate: offlineAwardLeaderSignoffValidate
})
class TaskOfflineAwardLeaderSignoff extends Component {
  static propTypes = {
    awardId: PropTypes.number.isRequired,

    handleSubmit: PropTypes.func,
    modal: PropTypes.func,
    isGold: PropTypes.bool.isRequired,
    onAwardChange: PropTypes.func.isRequired
  }

  static defaultProps = {
    title: 'Approve',
    intlKey: 'tasks.approve_item',
    withNote: false
  }

  handleDismiss = () => this.props.modal(null)

  render() {
    const {
      awardId,

      handleSubmit,
      isGold,
      onAwardChange
    } = this.props

    const checkboxes = [
      {
        id: 1,
        name: 'helpers.physical_recreation',
        label: 'Physical recreation',
        intlKey: 'award.physical_recreation',
        disabled: false
      },
      {
        id: 2,
        name: 'helpers.skills',
        label: 'Skills',
        intlKey: 'award.skills',
        disabled: false
      },
      {
        id: 3,
        name: 'helpers.service',
        label: 'Service',
        intlKey: 'award.service',
        disabled: false
      },
      {
        id: 4,
        name: 'helpers.rp',
        label: 'Residential Project',
        intlKey: 'award.rp',
        disabled: !isGold
      },
      {
        id: 5,
        name: 'helpers.aj',
        label: 'Adventurous Journey',
        intlKey: 'award.aj',
        disabled: false
      }
    ]

    return (
      <form
        onSubmit={handleSubmit(values =>
          onAwardChange(awardId, PROGRESS_STATES.awardLeaderSignoff.id, {
            note: values.note
          })
        )}
      >
        <h2 className="text--center">
          <FormattedMessage
            id="moduleTitle.offline_award_units_signoff"
            defaultMessage="Offline Award Leader signoff"
          />
        </h2>
        <div className="row">
          <div className="col-xs-12">
            <Textarea name="note" label="Note" />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <div className="base-margin--smaller">
              <Span intlKey="label.i_confirm_that_ive_witnessed">
                I confirm that I've witnessed the Participants log book for the activities below
              </Span>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <div className="base-margin">
              {checkboxes.map(item => (
                <Checkbox
                  key={item.id}
                  name={item.name}
                  label={item.label}
                  intlKey={item.intlKey}
                  disabled={item.disabled}
                />
              ))}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-6">
            <Button type="button" secondary onClick={this.handleDismiss}>
              <FormattedMessage id="button.dismiss" defaultMessage="Dismiss" />
            </Button>
          </div>
          <div className="col-xs-6 text--right">
            <Button>
              <FormattedMessage id="button.approve" defaultMessage="Approve" />
            </Button>
          </div>
        </div>
      </form>
    )
  }
}

export default TaskOfflineAwardLeaderSignoff
